import { z } from "zod";
import { DOC_CODE, DOC_NAME,
  DESCRIPTION,
  IS_REQUIRED,
  DISPLAY_ORDER,
  FILE_TYPES,
  MAX_FILE_SIZE,
  STATUS, 
  OCP_STAGE} from "./consts";

export const schema = z.object({
  [DOC_CODE]: z.string().min(1, "This field is required"),
  [DOC_NAME]: z.string().min(1, "This field is required"),
  [DESCRIPTION]: z.string().optional(),
  [IS_REQUIRED]: z.boolean().optional(),
  [DISPLAY_ORDER]: z.string().min(1, "This field is required"),
  [OCP_STAGE]: z.string().min(1, "This field is required"),
  [FILE_TYPES]: z.array(z.string()).min(1, "This field is required"),
  [MAX_FILE_SIZE]: z.string().min(1, "This field is required"),
  [STATUS]: z.boolean().optional(),
});

export type formValues = z.infer<typeof schema>;
